import Body from 'commons/card/Body';
import CollapsableCard from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import React from 'react';
import PropTypes from 'prop-types';

export default function ErrorCard(props) {
  return (
    <CollapsableCard canCollapse={false} type={'error'}>
      <Header title={props.title} />
      <Body>
        <h2>Désolé, une erreur est survenue. </h2>
      </Body>
    </CollapsableCard>
  );
}

ErrorCard.propTypes = {
  title: PropTypes.string,
};
